import { Box, FormControl } from "@chakra-ui/react";
import { Select } from "chakra-react-select";

type AppSelectProps = {
  id: string;
  name: string;
  value: string[] | string;
  placeholder: string;
  options: any[];
  onChange: any;
  isMulti?: boolean;
  isAsync?: boolean;
  isLoading?: boolean;
  handleInputChange?: any;
  getOptionLabel?: any;
  filterOption?: any;
  onBlur?: any;
  showErrorMessage?: any;
  errorMessage?: any;
  height?: any;
  width?: any;
  setFieldTouched?: any;
};

const AppSelect = ({
  name,
  value,
  placeholder,
  options,
  onChange,
  id,
  handleInputChange,
  onBlur,
  showErrorMessage,
  errorMessage,
  getOptionLabel,
  filterOption,
  width,
  height="40px",
  isMulti = false,
  isLoading = true,
}: AppSelectProps) => {
  // S'assurer que options est toujours un tableau
  const safeOptions = Array.isArray(options) ? options : [];
  return (
    <>
      <FormControl>
        <Box
        width={width}
          height={height}
          borderWidth="1px"
          alignSelf="stretch"
          borderRadius="8px"
          borderColor={"gray_stroke.0"}
        >
          {isMulti ? (
            <Select
              isLoading={isLoading}
              onInputChange={handleInputChange}
              isMulti
              name={name}
              options={safeOptions}
              placeholder={placeholder}
              closeMenuOnSelect={false}
              value={value}
              onChange={(newValue: any) => {
                onChange(name, newValue);
              }}
              id={id}
              getOptionLabel={getOptionLabel || ((option: any) => option.name)}
              getOptionValue={(option: any) => option.id}
              onBlur={(e: any) =>
                onBlur ? onBlur({ target: { name: name } }) : null
              }
              blurInputOnSelect
            />
          ) : (
            <Select
              isLoading={isLoading}
              placeholder={placeholder}
              onInputChange={handleInputChange}
              value={
                safeOptions?.find((option) => option.id === +value) || null
              }
              isClearable={true}
              isSearchable={true}
              name={name}
              id={id}
              onChange={(newValue: any) => {
                onChange(name, newValue?.id, newValue);
              }}
              options={safeOptions}
              getOptionLabel={(option: any) => option.name}
              getOptionValue={(option: any) => option.id}
              onBlur={(e: any) =>
                onBlur ? onBlur({ target: { name: name } }) : null
              }
              blurInputOnSelect
              filterOption={filterOption}
              chakraStyles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: height,   // minimum height
                  height: height,      // fixed height
                }),
                input: (provided) => ({
                  ...provided,
                  margin: '0px',
                  height: height,
                }),
                valueContainer: (provided) => ({
                  ...provided,
                  height: height,
                  padding: '0 4px',
                }),
                indicatorsContainer: (provided) => ({
                  ...provided,
                  height: height,
                }),
              }}
            />
          )}
        </Box>
        {showErrorMessage && !value && (
          <span style={{ color: "red", fontSize: "14px" }}>{errorMessage}</span>
        )}
      </FormControl>
    </>
  );
};

export default AppSelect;
